export default __webpack_public_path__ + "content/media/descargarevistasate.e6ca734f.png";